import { eventTracker, toast, useUser } from '@hakimo-ui/hakimo/util';
import {
  Alert,
  Button,
  Modal,
  Radio,
  Textarea,
} from '@hakimo-ui/shared/ui-base';
import { useState } from 'react';
import useSendFeedback from './useSendFeedback';
import {
  RadioItem,
  getFeedbackPayload,
  isValidFeedback,
  radioItems,
} from './util';

interface Props {
  onClose: () => void;
}

export function FeedbackModal(props: Props) {
  const { onClose } = props;

  const user = useUser();
  const [type, setType] = useState<RadioItem>(radioItems[0]);
  const [description, setDescription] = useState<string>('');

  const mutation = useSendFeedback(() => {
    toast('Thanks! Sent to the team.', { type: 'success' });
    onClose();
  });

  const onSubmit = () => {
    if (!isValidFeedback(description)) {
      return;
    }
    mutation.mutate(getFeedbackPayload(type.id, description, user.email));
  };

  const actions = (
    <>
      <Button
        variant="primary"
        onClick={onSubmit}
        loading={mutation.isLoading}
        disabled={mutation.isLoading || !isValidFeedback(description)}
        onSideEffect={eventTracker('submit_feedback')}
      >
        Submit
      </Button>
      <Button onClick={onClose} onSideEffect={eventTracker('cancel_feedback')}>
        Cancel
      </Button>
    </>
  );

  return (
    <Modal
      title="Report a bug / send feedback"
      footer={actions}
      open
      onClose={onClose}
    >
      {mutation.isError && (
        <div className="px-8 pt-2">
          <Alert type="error">{mutation.error.message}</Alert>
        </div>
      )}
      <div className="w-[30rem] p-8">
        <Radio
          items={radioItems}
          value={type}
          onChange={setType}
          layout="horizontal"
          label="What are you reporting?"
          id={(item: RadioItem) => item.id}
          displayValue={(item: RadioItem) => item.name}
        />
        <div className="mt-6">
          <Textarea
            value={description}
            onChange={setDescription}
            label="Details"
            placeholder="What happened? What did you expect?"
          />
        </div>
        <p className="dark:text-dark-secondary-text mt-2 text-xs text-gray-500">
          Page URL, your email and the release tag are attached automatically.
        </p>
      </div>
    </Modal>
  );
}

export default FeedbackModal;
